import {
	CoverStateActions,
	ADDITIONAL_COVER_CLOSED,
	ADDITIONAL_COVER_ITEM_CLICKED,
	SET_ADDITIONAL_COVER_ITEMS,
	SET_SELECTED_COVER,
	SET_COVER_ITEMS,
	SET_REPLACE_COVER_ITEMS,
	SHOW_COVER_PRODUCT_DESCRIPTION,
	SET_MISSING_COVER,
	SET_NOT_PRELOADED_COVERS,
	SET_COVER_ONLY,
	SET_COVER_ONLY_ITEMS,
	CLEAR_ADDITIONAL_COVER_ITEMS,
	ADD_ADDITIONAL_COVER,
	ADDITIONAL_COVER_ITEM_REMOVED,
} from './types';
import { CoverItem, ShoppingItem } from 'sofa-reborn-react';

export function setSelectedCover(
	value: CoverItem,
	origin: 'product-intro-gallery' | 'cover-picker'
): CoverStateActions {
	return {
		type: SET_SELECTED_COVER,
		value,
		origin,
	};
}

export function setCoverItems(value: CoverItem[]): CoverStateActions {
	return {
		type: SET_COVER_ITEMS,
		value,
	};
}

export function setReplaceCoverItems(value: CoverItem[]): CoverStateActions {
	return {
		type: SET_REPLACE_COVER_ITEMS,
		value,
	};
}

export function showCoverProductDescription(value: boolean): CoverStateActions {
	return {
		type: SHOW_COVER_PRODUCT_DESCRIPTION,
		value,
	};
}

export function setMissingCover(value: boolean): CoverStateActions {
	return {
		type: SET_MISSING_COVER,
		value,
	};
}

export function setNotPreloadedCovers(value: string[] | null): CoverStateActions {
	return {
		type: SET_NOT_PRELOADED_COVERS,
		value,
	};
}

export function setCoverOnly(value: boolean): CoverStateActions {
	return {
		type: SET_COVER_ONLY,
		value,
	};
}

export function setCoverOnlyItems(value: CoverItem[]): CoverStateActions {
	return {
		type: SET_COVER_ONLY_ITEMS,
		value,
	};
}

export function addAdditionalCover(coverName: string): CoverStateActions {
	return {
		type: ADD_ADDITIONAL_COVER,
		coverName,
	};
}

export function setAdditionalCoverItems(value: ShoppingItem[]): CoverStateActions {
	return {
		type: SET_ADDITIONAL_COVER_ITEMS,
		value,
	};
}

export function additionalCoverItemClicked(value: string): CoverStateActions {
	return {
		type: ADDITIONAL_COVER_ITEM_CLICKED,
		value,
	};
}

export function additionalCoverClosed(): CoverStateActions {
	return {
		type: ADDITIONAL_COVER_CLOSED,
	};
}

export function additionalCoverItemRemoved(article: string): CoverStateActions {
	return {
		type: ADDITIONAL_COVER_ITEM_REMOVED,
		article,
	};
}

export function clearAdditionalCoverItems(): CoverStateActions {
	return {
		type: CLEAR_ADDITIONAL_COVER_ITEMS,
	};
}
